module.exports = __webpack_public_path__ + "img/partone_pic2.3c05e9ff.png";